export const CHANGELOG_MAX_RELEASES = 20;

export function splitChangelogSections(changelog: string): string[] {
    return changelog
        .trim()
        .split(/^(?= *# +)/m)
        .map(section => section.trim());
}

export function splitChangelog(
    changelog: string,
    lastSeenVersion: string | null
): { latest: string; old: string } {
    const split = splitChangelogSections(changelog);

    const lastVersionHeader = `# ${lastSeenVersion}some filler for finding correct index`;
    const lastVersionIndex = split[0].match(/^# \d{4}\.\d{2}\.\d{2}/)
        ? split.findIndex(section => section < lastVersionHeader)
        : split.slice(1).findIndex(section => section < lastVersionHeader) + 1;

    if (lastVersionIndex === -1) {
        return { latest: '', old: split.slice(0, CHANGELOG_MAX_RELEASES).join('\n') };
    }

    return {
        latest: split.slice(0, lastVersionIndex).join('\n'),
        old: split.slice(lastVersionIndex, CHANGELOG_MAX_RELEASES).join('\n'),
    };
}

export function hasUnreadChangelog(
    changelog: string,
    lastSeenVersion: string | null
): boolean {
    return splitChangelog(changelog, lastSeenVersion).latest.trim().length > 0;
}

export function shouldShowStartupChangelog(
    changelog: string,
    lastSeenVersion: string | null,
    currentVersion: string,
    environment: string
): boolean {
    return (
        environment !== 'local' &&
        lastSeenVersion !== currentVersion &&
        hasUnreadChangelog(changelog, lastSeenVersion)
    );
}
